module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "boxReagendar"
    }
  }, [_c('h3', [_vm._v("Reagendar/ Aguardando Retorno/ Devolver Ficha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisar em Reagendar/ Devolver Ficha"
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredData), function(item) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(item.IdFichaAprovacao) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(" " + _vm._s(item.Nome) + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(item.Cpf) + " ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selecionados),
        expression: "selecionados"
      }],
      attrs: {
        "type": "checkbox",
        "title": "Selecionar"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.selecionados) ? _vm._i(_vm.selecionados, item) > -1 : (_vm.selecionados)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selecionados,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selecionados = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selecionados = $$c
          }
        }
      }
    })])])
  }), _vm._v(" "), (_vm.items.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Não há resultados para exibir")])]) : _vm._e()], 2), _vm._v(" "), _c('tfoot', [_c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.acessoBotoes),
      expression: "acessoBotoes"
    }]
  }, [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "4"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Iniciar Atendimento",
      "disabled": _vm.habilitarBotoes
    },
    on: {
      "click": _vm.fazerAtendimento
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadAtendimento),
      expression: "!loadAtendimento"
    }],
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadAtendimento),
      expression: "loadAtendimento"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Devolver Ficha de Aprovação",
      "disabled": _vm.habilitarBotoes
    },
    on: {
      "click": _vm.devolverFicha
    }
  }, [_c('i', {
    staticClass: "fa fa-undo",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "title": "Remover/Finalizar",
      "disabled": _vm.habilitarBotoes
    },
    on: {
      "click": _vm.removerFinalizar
    }
  }, [_c('i', {
    staticClass: "fa fa-remove",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Ficha Aprov.")]), _vm._v(" "), _c('td', [_vm._v("Nome")]), _vm._v(" "), _c('td', [_vm._v("CPF")]), _vm._v(" "), _c('td')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f08954e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reagendar.vue
// module id = 296
// module chunks = 1